import { render, staticRenderFns } from "./extendTeachManage.vue?vue&type=template&id=e622fcfe&scoped=true&"
import script from "./extendTeachManage.vue?vue&type=script&lang=js&"
export * from "./extendTeachManage.vue?vue&type=script&lang=js&"
import style0 from "./extendTeachManage.vue?vue&type=style&index=0&id=e622fcfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e622fcfe",
  null
  
)

export default component.exports